import Unmatched from '@/screens/Unmatched';

export default function UnmatchedRoute() {
  return <Unmatched />;
}
